"use client"

import React, { Component } from "react"
import { connect } from "react-redux"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"
import { Editor } from "@toast-ui/react-editor"
import "@toast-ui/editor/dist/toastui-editor.css"
import TitleBoxContent from "../../../components/pages/TitleContent"
import actionTypes from "../../../constants/actionTypes"
import DOMPurify from "dompurify"

class ChurchNewsWrite extends Component {
    constructor(props) {
        super(props)
        this.editorRef = React.createRef()
        this.state = {
            title: "",
            category: "공지사항",
            content: "",
            isEditing: false,
        }
    }

    componentDidMount() {
        const isEdit = window.location.pathname.includes("/edit/")
        if (isEdit) {
            this.loadEditData()
        }

    }

    componentDidUpdate(prevProps) {
        const { writeSuccess, writeError } = this.props

        // 글쓰기 성공 시
        if (!prevProps.writeSuccess && writeSuccess) {
            alert("게시글이 등록되었습니다.")
            // 취소 확인 없이 바로 목록으로 이동
            this.navigateToList()
        }

        // 글쓰기 실패 시
        if (!prevProps.writeError && writeError) {
            alert(`저장에 실패했습니다: ${writeError}`)
        }
    }

    // 목록으로 이동하는 함수 추가
    navigateToList = () => {
        window.location.href = "/church-news"
    }

    loadEditData = () => {
        this.setState({
            isEditing: true,
            title: "2024년 성실교회 여름 수련회 안내",
            category: "공지사항",
            content: "기존 게시글 내용...",
        })
    }

    handleTitleChange = (e) => {
        const title = e.target.value
        if (title.length <= 100) {
            this.setState({ title })
        }
    }

    handleCategoryChange = (e) => {
        this.setState({ category: e.target.value })
    }

    handleEditorChange = () => {
        if (this.editorRef.current) {
            // HTML 형태로 내용 가져오기
            const content = this.editorRef.current.getInstance().getHTML()
            this.setState({ content })
        }
    }

    handleSave = async () => {
        const { title, category, isEditing } = this.state
        const { dispatch, loginInfo } = this.props

        // HTML 형태로 내용 가져오기
        const content = this.editorRef.current?.getInstance().getHTML() || ""

        // XSS 방지를 위한 HTML Sanitization
        const sanitizedContent = DOMPurify.sanitize(content, {
            ALLOWED_TAGS: [
                "p",
                "br",
                "strong",
                "b",
                "em",
                "i",
                "u",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "ul",
                "ol",
                "li",
                "blockquote",
                "a",
                "img",
                "table",
                "thead",
                "tbody",
                "tr",
                "th",
                "td",
            ],
            ALLOWED_ATTR: ["href", "src", "alt", "title", "target", "rel"],
            ALLOW_DATA_ATTR: false,
            FORBID_SCRIPT: true,
            FORBID_TAGS: ["script", "object", "embed", "form", "input", "button"],
            FORBID_ATTR: ["onload", "onerror", "onclick", "onmouseover", "onfocus", "onblur", "onchange", "onsubmit"],
        })

        if (!title.trim()) {
            alert("제목을 입력해주세요.")
            return
        }

        if (!sanitizedContent.trim() || sanitizedContent === "<p><br></p>") {
            alert("내용을 입력해주세요.")
            return
        }

        // 로그인 정보 확인 - 더 안전한 체크
        if (!loginInfo) {
            alert("로그인 정보를 불러올 수 없습니다. 페이지를 새로고침해주세요.")
            return
        }

        if (!loginInfo.isLogin) {
            alert("로그인이 필요합니다.")
            return
        }

        if (!loginInfo.id) {
            alert("사용자 정보를 확인할 수 없습니다. 다시 로그인해주세요.")
            return
        }

        const boardData = {
            boardId: 1, // 실제 게시판 ID로 변경 필요
            title: title.trim(),
            contents: sanitizedContent, // Sanitized HTML 내용 전송
            createId: loginInfo.id,
        }


        dispatch({
            type: actionTypes.BOARD_WRITE,
            payload: boardData,
        })
    }

    handleCancel = () => {
        if (window.confirm("작성을 취소하시겠습니까?")) {
            this.navigateToList()
        }
    }

    render() {
        const { title, category, isEditing } = this.state
        const { writeLoading, loginInfo } = this.props

        const editorToolbarItems = [
            ["heading", "bold", "italic", "strike"],
            ["hr", "quote"],
            ["ul", "ol", "task"],
            ["table", "image", "link"],
            ["code", "codeblock"],
        ]

        return (
            <section className="pf-page">
                <PC>
                    <div className="write-page">
                        <div className="write-container">
                            <div className="write-form">
                                <div className="form-row">
                                    <div className="form-field category-field">
                                        <label>카테고리</label>
                                        <select className="category-select" value={category} onChange={this.handleCategoryChange}>
                                            <option value="공지사항">공지사항</option>
                                            <option value="모집">모집</option>
                                            <option value="행사">행사</option>
                                            <option value="기타">기타</option>
                                        </select>
                                    </div>

                                    <div className="form-field title-field">
                                        <label>
                                            제목
                                            <span className="char-counter">({title.length}/100)</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="title-input"
                                            value={title}
                                            onChange={this.handleTitleChange}
                                            placeholder="제목을 입력하세요"
                                            maxLength={100}
                                        />
                                    </div>
                                </div>

                                <div className="form-field content-field">
                                    <label>내용</label>
                                    <div className="editor-container">
                                        <Editor
                                            ref={this.editorRef}
                                            initialValue={this.state.content}
                                            previewStyle="tab"
                                            height="500px"
                                            initialEditType="wysiwyg"
                                            useCommandShortcut={true}
                                            toolbarItems={editorToolbarItems}
                                            onChange={this.handleEditorChange}
                                            language="ko-KR"
                                            placeholder="내용을 입력하세요..."
                                            hideModeSwitch={true}
                                        />
                                    </div>
                                </div>

                                <div className="form-actions">
                                    <button type="button" className="btn-cancel" onClick={this.handleCancel} disabled={writeLoading}>
                                        취소
                                    </button>
                                    <button type="button" className="btn-submit" onClick={this.handleSave} disabled={writeLoading}>
                                        {writeLoading ? "저장 중..." : isEditing ? "수정" : "등록"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </PC>

                <Notebook>
                    <div className="write-page">
                        <TitleBoxContent title="공지사항" />
                        <div className="write-container">
                            <div className="write-form">
                                <div className="form-row">
                                    <div className="form-field category-field">
                                        <label>카테고리</label>
                                        <select className="category-select" value={category} onChange={this.handleCategoryChange}>
                                            <option value="공지사항">공지사항</option>
                                            <option value="모집">모집</option>
                                            <option value="행사">행사</option>
                                            <option value="기타">기타</option>
                                        </select>
                                    </div>

                                    <div className="form-field title-field">
                                        <label>
                                            제목
                                            <span className="char-counter">({title.length}/100)</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="title-input"
                                            value={title}
                                            onChange={this.handleTitleChange}
                                            placeholder="제목을 입력하세요"
                                            maxLength={100}
                                        />
                                    </div>
                                </div>

                                <div className="form-field content-field">
                                    <label>내용</label>
                                    <div className="editor-container">
                                        <Editor
                                            ref={this.editorRef}
                                            initialValue={this.state.content}
                                            previewStyle="tab"
                                            height="450px"
                                            initialEditType="wysiwyg"
                                            useCommandShortcut={true}
                                            toolbarItems={editorToolbarItems}
                                            onChange={this.handleEditorChange}
                                            language="ko-KR"
                                            placeholder="내용을 입력하세요..."
                                            hideModeSwitch={true}
                                        />
                                    </div>
                                </div>

                                <div className="form-actions">
                                    <button type="button" className="btn-cancel" onClick={this.handleCancel} disabled={writeLoading}>
                                        취소
                                    </button>
                                    <button type="button" className="btn-submit" onClick={this.handleSave} disabled={writeLoading}>
                                        {writeLoading ? "저장 중..." : isEditing ? "수정" : "등록"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Notebook>

                <Tablet>
                    <div className="write-page tablet">
                        <TitleBoxContent title="공지사항" />
                        <div className="write-container">
                            <div className="write-form">
                                <div className="form-field">
                                    <label>카테고리</label>
                                    <select className="category-select" value={category} onChange={this.handleCategoryChange}>
                                        <option value="공지사항">공지사항</option>
                                        <option value="모집">모집</option>
                                        <option value="행사">행사</option>
                                        <option value="기타">기타</option>
                                    </select>
                                </div>

                                <div className="form-field">
                                    <label>
                                        제목
                                        <span className="char-counter">({title.length}/100)</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="title-input"
                                        value={title}
                                        onChange={this.handleTitleChange}
                                        placeholder="제목을 입력하세요"
                                        maxLength={100}
                                    />
                                </div>

                                <div className="form-field content-field">
                                    <label>내용</label>
                                    <div className="editor-container">
                                        <Editor
                                            ref={this.editorRef}
                                            initialValue={this.state.content}
                                            previewStyle="tab"
                                            height="400px"
                                            initialEditType="wysiwyg"
                                            useCommandShortcut={true}
                                            toolbarItems={[
                                                ["heading", "bold", "italic"],
                                                ["ul", "ol"],
                                                ["image", "link"],
                                            ]}
                                            onChange={this.handleEditorChange}
                                            language="ko-KR"
                                            placeholder="내용을 입력하세요..."
                                            hideModeSwitch={true}
                                        />
                                    </div>
                                </div>

                                <div className="form-actions">
                                    <button type="button" className="btn-cancel" onClick={this.handleCancel} disabled={writeLoading}>
                                        취소
                                    </button>
                                    <button type="button" className="btn-submit" onClick={this.handleSave} disabled={writeLoading}>
                                        {writeLoading ? "저장 중..." : isEditing ? "수정" : "등록"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Tablet>

                <Mobile>
                    <div className="write-page mobile">
                        <TitleBoxContent title="공지사항" />
                        <div className="write-container">
                            <div className="write-form">
                                <div className="form-field">
                                    <label>카테고리</label>
                                    <select className="category-select" value={category} onChange={this.handleCategoryChange}>
                                        <option value="공지사항">공지사항</option>
                                        <option value="모집">모집</option>
                                        <option value="행사">행사</option>
                                        <option value="기타">기타</option>
                                    </select>
                                </div>

                                <div className="form-field">
                                    <label>
                                        제목
                                        <span className="char-counter">({title.length}/100)</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="title-input"
                                        value={title}
                                        onChange={this.handleTitleChange}
                                        placeholder="제목을 입력하세요"
                                        maxLength={100}
                                    />
                                </div>

                                <div className="form-field content-field">
                                    <label>내용</label>
                                    <div className="editor-container">
                                        <Editor
                                            ref={this.editorRef}
                                            initialValue={this.state.content}
                                            previewStyle="tab"
                                            height="350px"
                                            initialEditType="wysiwyg"
                                            useCommandShortcut={true}
                                            toolbarItems={[
                                                ["heading", "bold", "italic"],
                                                ["ul", "ol"],
                                                ["image", "link"],
                                            ]}
                                            onChange={this.handleEditorChange}
                                            language="ko-KR"
                                            placeholder="내용을 입력하세요..."
                                            hideModeSwitch={true}
                                        />
                                    </div>
                                </div>

                                <div className="form-actions">
                                    <button type="button" className="btn-cancel" onClick={this.handleCancel} disabled={writeLoading}>
                                        취소
                                    </button>
                                    <button type="button" className="btn-submit" onClick={this.handleSave} disabled={writeLoading}>
                                        {writeLoading ? "저장 중..." : isEditing ? "수정" : "등록"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Mobile>
            </section>
        )
    }
}

const mapStateToProps = (state) => ({
    writeLoading: state.board?.write?.loading || false,
    writeSuccess: state.board?.write?.success || false,
    writeError: state.board?.write?.error || null,
    loginInfo: state.login || {}, // 기본값 설정
})

export default connect(mapStateToProps)(ChurchNewsWrite)
